import { createFileRoute } from "@tanstack/react-router";
import { ExerciseLayout } from "@/components/exercise-layout";

export const Route = createFileRoute("/prod")({
  component: () => <ExerciseLayout id="prod" />,
});
